
export default {
  state: {
    msg: 'aaaa'
  },
  actions: {
    newTest ({ commit }, msg) {
      commit('setTest', msg)
    }
  },
  mutations: {
    setTest (state, name) {
      state.msg = name
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/test.js